import tiktok from '@/assets/networks/tiktok.svg';
import applovin from '@/assets/networks/applovin_icon.png';
import googleAds from '@/assets/networks/Google_Ads_icon.svg';
import kayzen from '@/assets/networks/kayzen_icon.png';
import meta from '@/assets/networks/Meta_logo.png';
import mintegral from '@/assets/networks/Mintegral_logo.png';
import unity from '@/assets/networks/unity_ads.png';
import youtube from '@/assets/networks/Youtube_icon.avif';

export type NetworkId = 'tiktok_ads' | 'applovin' | 'unity' | 'mintegral' | 'kayzen' | 'meta_ads' | 'google_ads' | 'youtube';

export const NETWORKS: Record<NetworkId, { name: string; logo: string }> = {
  tiktok_ads: { name: 'TikTok Ads', logo: tiktok },
  applovin: { name: 'AppLovin', logo: applovin },
  unity: { name: 'Unity Ads', logo: unity },
  mintegral: { name: 'Mintegral', logo: mintegral },
  kayzen: { name: 'Kayzen', logo: kayzen },
  meta_ads: { name: 'Meta Ads', logo: meta },
  google_ads: { name: 'Google Ads', logo: googleAds },
  // Not an ad network (Connections → Other connections).
  youtube: { name: 'YouTube', logo: youtube },
};

/** API spellings → one id. `facebook_ads` is shown as Meta Ads (parity §0). */
const ALIASES: Record<string, NetworkId> = {
  tiktok: 'tiktok_ads', tiktok_ads: 'tiktok_ads',
  applovin: 'applovin',
  unity: 'unity',
  unity_ads: 'unity',
  unityads: 'unity',
  mintegral: 'mintegral',
  kayzen: 'kayzen',
  meta: 'meta_ads',
  meta_ads: 'meta_ads',
  facebook: 'meta_ads',
  facebook_ads: 'meta_ads',
  google: 'google_ads',
  google_ads: 'google_ads',
  googleads: 'google_ads',
  youtube: 'youtube',
};

export const resolveNetwork = (raw: string): NetworkId | null =>
  ALIASES[raw.trim().toLowerCase().replace(/[\s-]+/g, '_')] ?? null;

export const networkName = (raw: string): string => {
  const id = resolveNetwork(raw);
  return id ? NETWORKS[id].name : raw;
};
